// extracted by mini-css-extract-plugin
export default {"menu-card-container":"styles_menu-card-container__v5Lyp"};